import { F0AiBanner } from '@factorialco/f0-react/dist/experimental'
import { AtsAiSummaryFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

interface Props {
  data: AtsAiSummaryFragment
}

export const AISummary = ({ data }: Props) => {
  const parsedDetails = JSON.parse(data.details)
  const reflection = parsedDetails.reflection

  const title = data?.topMatch
    ? i18n.t('ats.application_details.ai_summary.title_match')
    : i18n.t('ats.application_details.ai_summary.title')

  return reflection ? <F0AiBanner title={title} content={reflection} /> : null
}
